function friendlyResponseError({ status, statusText, ...rest }, data, error) {

  const genericErrorMessage = `Hubo un error, status ${status}`;

  const dictErrorMessagesByStatus = {
    401: 'request_feedbacks.401',
    403: 'request_feedbacks.403',
    404: 'request_feedbacks.404',
  };

  const friendlyErrorMessage = dictErrorMessagesByStatus[status] || genericErrorMessage;

  return {
    fem: friendlyErrorMessage,
    status,
    statusText,
    friendlyErrorMessage,
    data,
    error,
    ...rest,
  };

}

export default friendlyResponseError;
